import AbstractEntity from "../AbstractEntity";

export default class Document extends AbstractEntity {
    static TYPE_QUOTATION = 0;
    static TYPE_REPORT_COMPLETION = 1;
    static TYPE_PICTURE_BEFORE = 2;
    static TYPE_PICTURE_AFTER = 3;

    static STATUS_FIXED = 0;
    static STATUS_PROVIDED = 1;
    static STATUS_ACCEPTED = 2;
    static STATUS_REFUSED = 3;
    static STATUS_UNNECESSARY = 4;

    _id;
    _type;
    _status;
    _fileId;
    _signedFileId;
    _signatureId;
    _createdAt;
    _interventionId;


    getId() {
        return this._id;
    }

    getType() {
        return this._type;
    }

    getStatus() {
        return this._status;
    }

    getFileId() {
        return this._fileId;
    }

    getSignedFileId() {
        return this._signedFileId;
    }

    getSignatureId() {
        return this._signatureId;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getClassName() {
        return "document";
    }
}
